import { linkStrategy, linkStrategyCTA } from '@/App.datalayer';
import { OnDatalayerProps } from '@/features/shared/HOCs/withGTM.interface';
import qs from 'query-string';

const events = new Map([
  ['menu-link', 'clickMenuLink'],
  ['contact-us', 'clickContactUs'],
  ['language', 'clickLanguage'],
  ['result', 'clickResult'],
]);

const registerEvents = new Map([
  ['portal', 'clickPortalReg'],
  ['stratocast', 'clickStratoReg'],
]);

export const onDatalayerCustom = ({ target }: OnDatalayerProps) => {
  if (!target) {
    return undefined;
  }

  const { q = '' } = qs.parse(window.location.search);
  const { searchQuery, variantName = '' } = target || {};

  return {
    event: 'searchQuery',
    eventCategory: 'Site Search',
    searchFilters: '',
    revision: q ? 'yes' : 'no',
    searchQuery,
    ...(variantName && { variant_name: variantName }),
  };
};

export const onDatalayerClickLegacy = ({ target }: OnDatalayerProps) => {
  const scenario = target?.getAttribute('data-datalayer-scenario');
  const href = target?.href || '';

  if (!scenario) {
    return undefined;
  }

  const content = target?.getAttribute('data-datalayer-content');
  const variantName = target?.getAttribute('data-datalayer-variant') || '';
  let event = events.get(scenario);

  if (scenario === 'register') {
    const registerTitle =
      target
        ?.closest('.secNavMenuGroupList')
        ?.querySelector('.secNavMenuGroupSectionTitleLink')
        ?.textContent?.trim()
        .toLowerCase() || '';

    const [registerKey] = Array.from(registerEvents).find(([key]) =>
      registerTitle.includes(key),
    ) || ['', ''];

    event = registerEvents.get(registerKey);
  }

  if (scenario === 'language') {
    return {
      event,
      eventCategory: 'Primary Nav',
      languageChoice: content,
      href,
      ...(variantName && { variant_name: variantName }),
    };
  }

  if (scenario === 'result') {
    return {
      event,
      eventCategory: 'Primary Nav',
      searchQuery: target.dataset.query,
      href,
      ...(variantName && { variant_name: variantName }),
    };
  }

  return {
    event,
    eventCategory: 'Primary Nav',
    href,
    ...(variantName && { variant_name: variantName }),
  };
};

export const onDatalayerClickLink = ({ target }: OnDatalayerProps) => {
  if (target?.getAttribute('data-datalayer-ignore-link')) return undefined;
  const variantName = target?.closest('[data-datalayer-variant]')?.dataset?.datalayerVariant || '';
  const position =
    target?.closest('[data-datalayer-position]')?.dataset?.datalayerPosition || 'primary_nav';
  return linkStrategy({ target, position, variant: variantName });
};

export const onDatalayerClickCTA = ({ target }: OnDatalayerProps) => {
  if (target?.getAttribute('data-datalayer-ignore-cta')) return undefined;

  const variantName = target?.closest('[data-datalayer-variant]')?.dataset?.datalayerVariant || '';
  return linkStrategyCTA({ target, position: 'primary_nav', variant: variantName });
};
